var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyRecordsSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M150 0H0V150H150V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75 135.934C107.585 135.934 134 109.518 134 76.9336C134 44.3488 107.585 17.9336 75 17.9336C42.4152 17.9336 16 44.3488 16 76.9336C16 109.518 42.4152 135.934 75 135.934Z",
    fill: "#C1C9D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.782 50.3291V124.953C115.782 126.209 115.283 127.414 114.395 128.303C113.506 129.191 112.301 129.691 111.044 129.691H37.6052C36.3486 129.691 35.1435 129.191 34.2549 128.303C33.3664 127.414 32.8672 126.209 32.8672 124.953V28.2263C32.8672 26.9697 33.3664 25.7646 34.2549 24.876C35.1435 23.9875 36.3486 23.4883 37.6052 23.4883H90.7064",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.782 50.3291V124.953C115.782 126.209 115.283 127.414 114.395 128.303C113.506 129.191 112.301 129.691 111.044 129.691H37.6052C36.3486 129.691 35.1435 129.191 34.2549 128.303C33.3664 127.414 32.8672 126.209 32.8672 124.953V28.2263C32.8672 26.9697 33.3664 25.7646 34.2549 24.876C35.1435 23.9875 36.3486 23.4883 37.6052 23.4883H90.7064",
    stroke: "#16408A",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0475 122.904C93.3973 122.904 108.273 108.028 108.273 89.6784C108.273 71.3286 93.3973 56.4531 75.0475 56.4531C56.6977 56.4531 41.8223 71.3286 41.8223 89.6784C41.8223 108.028 56.6977 122.904 75.0475 122.904Z",
    fill: "white",
    stroke: "#16408A",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0475 115.029C89.047 115.029 100.396 103.68 100.396 89.6804C100.396 75.6809 89.047 64.332 75.0475 64.332C61.0481 64.332 49.6992 75.6809 49.6992 89.6804C49.6992 103.68 61.0481 115.029 75.0475 115.029Z",
    stroke: "#16408A",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2432 30.6914H24.4094",
    stroke: "#16408A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8809 14V21.107",
    stroke: "#16408A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2871 19.1172L25.9609 23.488",
    stroke: "#16408A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.783 50.3291H95.8007C95.1241 50.3213 94.4556 50.1804 93.8334 49.9143C93.2112 49.6482 92.6475 49.2621 92.1745 48.7781C91.7016 48.2942 91.3286 47.7218 91.0768 47.0936C90.8251 46.4655 90.6996 45.7939 90.7074 45.1173V23.4883L115.783 50.3291Z",
    fill: "#16408A",
    stroke: "#16408A",
    strokeWidth: 0.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4111 42.6562H80.6027",
    stroke: "#16408A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4111 51.1719H60.0397",
    stroke: "#16408A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M117.415 131.657C117.048 132.068 116.604 132.403 116.107 132.642C115.61 132.88 115.071 133.019 114.521 133.048C113.97 133.078 113.419 132.999 112.9 132.815C112.38 132.631 111.902 132.346 111.493 131.976L95.5732 116.021C97.9031 114.231 99.9896 112.144 101.78 109.814L117.735 125.77C118.47 126.594 118.849 127.676 118.789 128.779C118.73 129.882 118.236 130.917 117.415 131.657V131.657Z",
    fill: "white",
    stroke: "#16408A",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3331 88.1837C64.7526 88.1837 65.9034 87.0329 65.9034 85.6133C65.9034 84.1938 64.7526 83.043 63.3331 83.043C61.9135 83.043 60.7627 84.1938 60.7627 85.6133C60.7627 87.0329 61.9135 88.1837 63.3331 88.1837Z",
    fill: "#16408A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7608 88.1837C88.1804 88.1837 89.3312 87.0329 89.3312 85.6133C89.3312 84.1938 88.1804 83.043 86.7608 83.043C85.3412 83.043 84.1904 84.1938 84.1904 85.6133C84.1904 87.0329 85.3412 88.1837 86.7608 88.1837Z",
    fill: "#16408A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.963 99.2509C78.7125 98.6701 77.3502 98.3691 75.9713 98.3691C74.5924 98.3691 73.2301 98.6701 71.9795 99.2509",
    stroke: "#16408A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRecordsSearch);
export default __webpack_public_path__ + "static/media/empty-records-search.aa6a413728eccf9f97e25b1c8a7b2545.svg";
export { ForwardRef as ReactComponent };